export const nav = {
  home: "Καλωσόρισμα",
  howItWorks: "Πώς λειτουργεί",
  discover: "Ανακάλυψε",
  explore: "Εξερεύνηση",
  exploreDesc: "Ανακάλυψε μέλη και προορισμούς",
  destinations: "Προορισμοί",
  destinationsDesc: "Περιήγηση στους διαθέσιμους προορισμούς",
  membersMap: "Χάρτης μελών",
  membersMapDesc: "Βρες μέλη κοντά σου",
  pricing: "Τιμές",
  dashboard: "Πίνακας ελέγχου",
  dashboardDesc: "Διαχειρίσου τις αγγελίες και ανταλλαγές σου",
  mySpace: "Ο χώρος μου",
  myCalendar: "Το ημερολόγιό μου",
  myCalendarDesc: "Διαχειρίσου το ημερολόγιο και τις ανταλλαγές σου",
  incomingRequests: "Έξυπνο ταίριασμα",
  incomingRequestsDesc: "Αιτήματα που ελήφθησαν και προτάσεις ΤΝ",
  favorites: "Αγαπημένα",
  favoritesDesc: "Οι αγαπημένοι σου προορισμοί",
  messaging: "Μηνύματα",
  messagingDesc: "Συνομιλίες και προτάσεις",
  login: "Σύνδεση",
  signup: "Εγγραφή",
  corporate: "Εταιρεία",
  announcement:
    "DONKEY TRAVEL — Η ευρωπαϊκή λέσχη ανταλλαγής σπιτιού προορίζεται για οικοδεσπότες Airbnb με βαθμολογία 4,5 και άνω",
};
